import React from "react"
import { useHistory } from "react-router-dom"
import clsx from "clsx"

import { Navbar, } from "components"
import sidebarItems from "./sidebarItems"
import classes from "./PvSidebar.module.scss"

const PvSidebar = (props) => {
  const {
    printType,
    setPrintType,
    setPrintData
  } = props

  const history = useHistory()

  const handleSelect = (item) => {
    setPrintData(item.printData)
    setPrintType(item.printType)
  }

  return (
    <div className={classes["sidebar"]}>
      <Navbar
        title="قالب پرینت"
        onLeftIconPress={() => history.push("/settings")}
      />
      <div className={classes["list"]}>
        {sidebarItems.map(item =>
          <div
            key={item.printType}
            onClick={() => handleSelect(item)}
            className={clsx(
              classes["sidebar-item"],
              item.printType === printType && classes["active"]
            )}
          >
            {item.name}
          </div>
        )}
      </div>
    </div >
  )
}

export default PvSidebar

